export class bs4Toast {

    static nextPadding: number = 10;
    static active: number = 0;

    static error(title = '', content = '', options: any = {}) {

        if (options.hasOwnProperty('headerClasses')) {
            options.headerClasses.push('bg-danger');
            options.headerClasses.push('text-white');
        } else {
            options['headerClasses'] = ['bg-danger', 'text-white'];
        }

        this.show(title, content, options);
    }

    static warning(title = '', content = '', options: any = {}) {

        if (options.hasOwnProperty('headerClasses')) {
            options.headerClasses.push('bg-warning');
            options.headerClasses.push('text-white');
        } else {
            options['headerClasses'] = ['bg-warning', 'text-white'];
        }

        this.show(title, content, options);
    }

    static primary(title = '', content = '', options: any = {}) {

        if (options.hasOwnProperty('headerClasses')) {
            options.headerClasses.push('bg-primary');
            options.headerClasses.push('text-white');
        } else {
            options['headerClasses'] = ['bg-primary', 'text-white'];
        }

        this.show(title, content, options);
    }

    static show(title = '', content = '', options: any = {}) {

        const id = 'bs4Toast' + this.active;

        let delayNumber = 3000;
        if (options.hasOwnProperty('delay')) {
            delayNumber = options.delay;
        }

        let hide = true;
        if (options.hasOwnProperty('autohide')) {
            hide = options.autohide;
        }

        const wrapper = document.createElement('div');
        wrapper.id = id.toString();
        wrapper.classList.add("bs4ToastWrapper");
        wrapper.classList.add("toast");
        wrapper.classList.add("mx-3")
        const areal_live = document.createAttribute("aria-live");
        const role = document.createAttribute("role");
        const atomic = document.createAttribute("aria-atomic");
        const autohide = document.createAttribute("data-autohide");
        const statedelay = document.createAttribute("data-delay");

        role.value = 'alert';
        areal_live.value = 'assertive';
        atomic.value = 'true';
        autohide.value = hide.toString();
        statedelay.value = delayNumber.toString();


        wrapper.setAttributeNode(areal_live);
        wrapper.setAttributeNode(role);
        wrapper.setAttributeNode(atomic);
        wrapper.setAttributeNode(statedelay);
        wrapper.setAttributeNode(autohide);


        const headerWrapper = document.createElement('div');
        headerWrapper.classList.add("toast-header");
        if (options.hasOwnProperty('headerClasses')) {
            jQuery.each(options.headerClasses, (e, v) => {
                headerWrapper.classList.add(v);
            })
        }
        const headerText = document.createElement('strong');
        headerText.classList.add("mr-auto");
        headerText.innerHTML = title;

        const closeButton = document.createElement('button');
        closeButton.classList.add("ml-2");
        closeButton.classList.add("mb-1");
        closeButton.classList.add("close");
        closeButton.classList.add("close-white")

        const dismissAttr = document.createAttribute("data-dismiss");
        const arialLab = document.createAttribute("aria-label");

        dismissAttr.value = 'toast';
        arialLab.value = 'Close';

        closeButton.setAttributeNode(dismissAttr);
        closeButton.setAttributeNode(arialLab);
        closeButton.innerHTML = '<span aria-hidden="true">&times;</span>';
        wrapper.style.marginTop = this.nextPadding.toString() + 'px';

        const bodyWrapper = document.createElement('div');
        bodyWrapper.classList.add("toast-body");
        if (options.hasOwnProperty('bodyClasses')) {
            jQuery.each(options.bodyClasses, (e, v) => {
                bodyWrapper.classList.add(v);
            })
        }
        bodyWrapper.innerHTML = content;

        if (options.hasOwnProperty('icon')) {
            if (options.icon.hasOwnProperty('type') == false) {
                console.error('bs4Toast : Icon type is missing in Object.');
            } else {
                if (options.icon.type == 'image') {
                    const imgwrapper = document.createElement('img');
                    const src = document.createAttribute("src");
                    imgwrapper.classList.add("rounded");
                    imgwrapper.classList.add("mr-2");
                    imgwrapper.classList.add("bs4Toasticonimage");
                    src.value = options.icon.src;
                    imgwrapper.setAttributeNode(src);
                    headerWrapper.appendChild(imgwrapper);
                    //this.nextPadding += 40;
                } else if (options.icon.type == "fontawesome") {
                    const iwrapper = document.createElement('i');
                    iwrapper.classList.add("bs4Toasticon");
                    iwrapper.classList.add("fa");
                    iwrapper.classList.add(options.icon.class);
                    headerWrapper.appendChild(iwrapper);
                    //this.nextPadding += 40; 
                } else {
                    console.error('bs4Toast : Icon type is should be image or fontawesome. Please go through the Docs.');
                }
            }
        }

        headerWrapper.appendChild(headerText);
        headerWrapper.appendChild(closeButton);
        wrapper.appendChild(headerWrapper);

        const hr = document.createElement('hr');
        if (options.hasOwnProperty('buttons')) {
            const p = document.createElement('div');
            p.classList.add("row");
            const col = 12 / options.buttons.length;
            jQuery.each(options.buttons, (e, v) => {
                const buttonDiv = document.createElement('div');
                buttonDiv.classList.add(`col-${col}`);
                const button = document.createElement('button');
                button.innerHTML = v.text;
                v.class.split(' ').forEach((e) => {
                    button.classList.add(e);
                });
                button.onclick = v.callback;
                p.appendChild(buttonDiv);
                buttonDiv.appendChild(button);
            });
            bodyWrapper.appendChild(p);
        }

        wrapper.appendChild(bodyWrapper);

        this.nextPadding += 100;
        document.body.prepend(wrapper);
        // @ts-ignore
        $('#' + id).toast('show');
        $('#' + id).on('hidden.bs.toast', () => {
            $('#' + id).remove();
            $('*.bs4ToastWrapper').each((e, y) => {
                const sel = $('#' + y.id);
                const marhing = parseInt(sel.css('margin-top').slice(0, -2).trim());
                const neMargin = marhing - 100;
                sel.css('margin-top', neMargin + 'px');
            });

            this.nextPadding -= 100;
        });
        this.active++;
        return false;
    }
}
